// @ts-nocheck
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { TypographyProps } from "@insite/mobius/Typography";
import merge from "lodash/merge";
import { css } from "styled-components";

const nameText: TypographyProps = {
    css: css`
        width: 100%;
        ${({ theme }) => `
            font-size: ${theme.design.typography.size.tiny};
            font-weight: ${theme.design.typography.weight.base};
        `}
        ${wrapInContainerStyles}
    `,
    transform: "uppercase",
};

merge(productBrandStyles, {
    nameText,
    nameLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: nameText,
    },
});
